/**
 * The character library's way into the GM's asset library (plan
 * assets-library, stage 2): **From my library…** copies character assets -
 * several at once (the user, 2026-10-20) - into the session's characters, and **Update…** brings a copy the library
 * has moved past up to its newest. Only for a GM whose account can host.
 *
 * An Update refreshes the SESSION LIBRARY's sheet; people already on the
 * roster keep the sheet they were loaded with (the plan's ruling).
 */
import { useState } from 'react';
import LibraryPicker from '../assets/LibraryPicker';
import { ownedRow, staleCopies } from '../../engine/assets/provenance';
import type { TableAssets } from '../../hooks/useShellDomainAssets';
import common from '../../styles/common.module.css';

export default function FromMyLibrary({ tableAssets }: { tableAssets: TableAssets }) {
  const [open, setOpen] = useState(false);
  const stale = staleCopies(tableAssets.characters, tableAssets.lib.assets);
  const update = (id: string) => {
    const copy = stale.find((c) => c.id === id);
    if (copy) void tableAssets.updateCharacter(copy);
  };
  return (
    <>
      <button
        type="button"
        className={common.btnSmall}
        data-testid="library-pick-character"
        onClick={() => setOpen(true)}
      >
        From my library…
      </button>
      {stale.length > 0 && (
        <select
          className={common.btnSmall}
          aria-label="Update a copy from my library"
          data-testid="library-character-update"
          value=""
          onChange={(e) => e.target.value && update(e.target.value)}
        >
          <option value="">Update…</option>
          {stale.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}: v{c.origin?.version} → v{ownedRow(tableAssets.lib.assets, c.origin)?.version}
            </option>
          ))}
        </select>
      )}
      {open && (
        <LibraryPicker
          lib={tableAssets.lib}
          uid={tableAssets.uid}
          kind="character"
          title="From my library · Characters"
          action="Copy into the session"
          copies={tableAssets.characters}
          onClose={() => setOpen(false)}
          onPick={(row) => {
            setOpen(false);
            void tableAssets.pickCharacters([row]);
          }}
          many={{
            label: (n) => (n ? `Copy ${n} into the session` : 'Copy into the session'),
            onPick: (rows) => {
              setOpen(false);
              void tableAssets.pickCharacters(rows);
            },
          }}
        />
      )}
    </>
  );
}
